var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hasProjects)?_c('report-not-configured-instance'):_c('vulnerability-report-tabs')}
var staticRenderFns = []

export { render, staticRenderFns }